import { initializeLanguage } from "./gettext-compile.config";

import "@vueup/vue-quill/dist/vue-quill.snow.css";
import "normalize.css";
import "./styles/app.scss";

// Some modules translate constants during import, before Vue mounts.
initializeLanguage().then(() => import("./bootstrap"));
